export default __webpack_public_path__ + "static/media/service.9310f7b4.png";